import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed-buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'FixedButtons',
  setup(__props) {


const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "top-button",
      onClick: scrollToTop
    }, " ⬆️ 최상단 "),
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      href: "https://open.kakao.com/o/sE8KmDEh",
      target: "_blank",
      rel: "noopener noreferrer",
      class: "kakao-chat-button",
      style: {"color":"black"}
    }, " 💬 카카오톡 문의 ", -1))
  ]))
}
}

})